module.exports = __webpack_public_path__ + "static/35-b4a4636c5e61f6d9530bbdafa04033ef.jpg";